export default [
	{
		modulo: 7,
		privilegio: 29,
		routerName: 'relatorioVoo',
		routerPath: '/relatorio-de-voo',
		componentName: 'RelatorioVoo',
		componentPath: 'modules/layout/relatorio/voo/alagoas/main',
		clientsComponentPath: [
			// id do ibama
			{
				clientId: [5],
				componentPath: 'modules/layout/relatorio/voo/ibama/main'
			},
			// ID DA AEROTERRA
			{
				clientId: [13, 21],
				componentPath: 'modules/layout/relatorio/voo/aeroterra/main'
			},
			// id do maranhao
			{
				clientId: [10],
				componentPath: 'modules/layout/relatorio/voo/maranhao/main'
			}
		]
	},
	{
		modulo: 7,
		privilegio: 22,
		routerName: 'relatorioHorasVoadas',
		routerPath: '/relatorio-de-horas-voadas',
		componentName: 'RelatorioHorasVoads',
		componentPath: 'modules/layout/relatorio/horas-voadas/default/main',
		clientsComponentPath: [
			// id do ibama
			{
				clientId: [5],
				componentPath: 'modules/layout/relatorio/horas-voadas/ibama/main'
			},
			// id pm-es
			{
				clientId: [18],
				componentPath: 'modules/layout/relatorio/horas-voadas/mg-siga/main'
			},
			// id do siga, pmsp, bm-df
			{
				clientId: [9, 30, 74, 75],
				componentPath: 'modules/layout/relatorio/horas-voadas/mg-siga/main'
			},
			// id do maranhao
			{
				clientId: [10],
				componentPath: 'modules/layout/relatorio/horas-voadas/maranhao/main'
			},
			// // id alagoas
			{
				clientId: [1],
				componentPath: 'modules/layout/relatorio/horas-voadas/alagoas/main'
			}
		]
	},
	{
		modulo: 7,
		privilegio: 374,
		routerName: 'relatorio-abastecimento-por-usuario',
		routerPath: '/relatorio-abastecimento-por-usuario',
		componentName: 'RelatorioAbastecimentoPorUsuario',
		componentPath: 'modules/layout/relatorio/abastecimento/aeronave-usuario'
	},
	{
		modulo: 7,
		privilegio: 403,
		routerName: 'relatorio-conferencia-diario-bordo',
		routerPath: '/relatorio-conferencia-diario-bordo',
		componentName: 'RelatorioConferenciaDiarioBordo',
		componentPath: 'modules/layout/relatorio/conferencia-diario-bordo/main'
	},
	{
		modulo: 7,
		privilegio: 340,
		routerName: 'relatorio-movimentacao-combustivel',
		routerPath: '/relatorio-movimentacao-combustivel',
		componentName: 'RelatorioMovimentacaoCombustivel',
		componentPath: 'modules/layout/relatorio/abastecimento/main'
	},

	{
		modulo: 7,
		privilegio: 342,
		routerName: 'relatorio-abastecimento-aeronave',
		routerPath: '/relatorio-abastecimento-aeronave',
		componentName: 'RelatorioAbastecimentoAeronave',
		componentPath: 'modules/layout/relatorio/abastecimento/aeronave'
	},

	{
		modulo: 7,
		privilegio: 341,
		routerName: 'relatorio-fornecedor-combustivel',
		routerPath: '/relatorio-fornecedor-combustivel',
		componentName: 'RelatorioUnidadeFornecedorCombustivel',
		componentPath:
			'modules/layout/relatorio/abastecimento/fornecedor_combustivel'
	},

	{
		modulo: 7,
		privilegio: 167,
		routerName: 'relatorioHorasRastreadas',
		routerPath: '/relatorio-de-horas-rastreadas',
		componentName: 'RelatorioHorasRastreadas',
		componentPath: 'modules/layout/relatorio/horas-rastreadas/default/main',
		clientsComponentPath: [
			// id pm-es
			{
				clientId: [18],
				componentPath: 'modules/layout/relatorio/horas-rastreadas/mg-siga/main'
			},
			// id do siga, pmsp, bm-df
			{
				clientId: [9],
				componentPath: 'modules/layout/relatorio/horas-rastreadas/mg-siga/main'
			}
		]
	},
	{
		modulo: 7,
		privilegio: 175,
		routerName: 'relatorioAeronavesMotor',
		routerPath: '/relatorio-aeronaves-por-motor',
		componentName: 'RelatorioAeronavesMotor',
		componentPath: 'modules/layout/relatorio/aeronaves-motor/mg-siga/main'
	},
	{
		modulo: 7,
		privilegio: 175,
		routerName: 'RelatorioMotoresAeronave',
		routerPath: '/relatorio-motores-aeronave',
		componentName: 'RelatorioMotoresAeronave',
		componentPath: 'modules/layout/relatorio/motores-aeronave/mg-siga/main'
	},
	{
		modulo: 7,
		privilegio: 176,
		routerName: 'RelatorioTrechosMotor',
		routerPath: '/relatorio-trechos-motor',
		componentName: 'RelatorioTrechosMotor',
		componentPath: 'modules/layout/relatorio/trecho-motor/mg-siga/main'
	},
	{
		modulo: 7,
		privilegio: 406,
		routerName: 'RelatorioAeromedico',
		routerPath: '/relatorio-aeromedico',
		componentName: 'RelatorioAeromedico',
		componentPath: 'modules/layout/relatorio/aeromedico/main'
	},
	{
		modulo: 7,
		privilegio: 140,
		routerName: 'relatorioHorasVoadasPiloto',
		routerPath: '/relatorio-horas-voadas-piloto',
		componentName: 'RelatorioHorasVoadasPiloto',
		componentPath: 'modules/layout/relatorio/horas-voadas-piloto/ibama/main'
	},
	{
		modulo: 7,
		privilegio: 32,
		routerName: 'relatorioEstaticaVoo',
		routerPath: '/relatorio-estatistica-de-voo',
		componentName: 'RelatorioEstatistica',
		componentPath: 'modules/layout/relatorio/estatistica-voo/alagoas/main',
		clientsComponentPath: [
			// id do ibama
			{
				clientId: [5],
				componentPath: 'modules/layout/relatorio/estatistica-voo/ibama/main'
			},
			// ID DA AEROTERRA
			{
				clientId: [13, 21],
				componentPath: 'modules/layout/relatorio/estatistica-voo/aeroterra/main'
			},
			// id do maranhao
			{
				clientId: [10],
				componentPath: 'modules/layout/relatorio/estatistica-voo/maranhao/main'
			}
		]
	},
	{
		modulo: 7,
		privilegio: 35,
		routerName: 'relatorioSolicitacao',
		routerPath: '/relatorio-solicitacao',
		componentName: 'RelatorioSolicitacao',
		componentPath: 'modules/layout/relatorio/solicitacao/ibama/main'
	},
	{
		modulo: 7,
		privilegio: 36,
		routerName: 'relatorioOrdem',
		routerPath: '/relatorio-ordem-missao',
		componentName: 'RelatorioOrdem',
		componentPath: 'modules/layout/relatorio/ordem-missao/ibama/main'
	},
	{
		modulo: 7,
		privilegio: 38,
		routerName: 'relatorioOperacao',
		routerPath: '/relatorio-relatorio-operacao',
		componentName: 'RelatorioOperacao',
		componentPath: 'modules/layout/relatorio/operacao/alagoas/main',
		clientsComponentPath: [
			// id do ibama
			{
				clientId: [5],
				componentPath: 'modules/layout/relatorio/operacao/ibama/main'
			}
		]
	},
	{
		modulo: 7,
		privilegio: 82,
		routerName: 'atividades-aereas',
		routerPath: '/relatorio-atividades-aereas',
		componentName: 'RelatorioOpAereas',
		componentPath: 'modules/layout/relatorio/atividades-aereas/alagoas/main'
	},
	{
		modulo: 7,
		privilegio: 99,
		routerName: 'perfil-usuario',
		routerPath: '/relatorio-perfil-usuario',
		componentName: 'RelatorioPerfil',
		componentPath: 'modules/layout/relatorio/perfil-usuario/mg-siga/main',
		clientsComponentPath: [
			// id do ibama
			{
				clientId: [5],
				componentPath: 'modules/layout/relatorio/perfil-usuario/ibama/main'
			}
		]
	},
	{
		modulo: 7,
		privilegio: 119,
		routerName: 'relatorio-diario-nao-assinado',
		routerPath: '/relatorio-diario-nao-assinado',
		componentName: 'RelatorioDiarioNaoAssinado',
		componentPath: 'modules/layout/relatorio/diario-nao-assinado/mg-siga/main'
	},
	{
		modulo: 7,
		privilegio: 130,
		routerName: 'extrato-db',
		routerPath: '/extrato-db',
		componentName: 'RelatorioExtratoDiarioDeBordo',
		componentPath: 'modules/layout/relatorio/extrato-diario-de-bordo/main'
	},
	{
		modulo: 7,
		privilegio: 129,
		routerName: 'meta-horas-voadas',
		routerPath: '/meta-horas-voadas',
		componentName: 'RelatorioMetaHorasVoadas',
		componentPath: 'modules/layout/relatorio/meta-horas-voadas/mg-siga/main'
	},
	{
		modulo: 7,
		privilegio: 131,
		routerName: 'auditoria-arquivo',
		routerPath: '/auditoria-arquivo',
		componentName: 'RelatorioAuditoria',
		componentPath: 'modules/layout/relatorio/auditoria-arquivo/main'
	},
	{
		modulo: 7,
		privilegio: 138,
		routerName: 'relatorio-alocacao-aeronaves',
		routerPath: '/relatorio-alocacao-aeronaves',
		componentName: 'RelatorioAlocacaoAeronaves',
		componentPath: 'modules/layout/relatorio/alocacao-aeronaves/ibama/main'
	},
	{
		modulo: 7,
		privilegio: 145,
		routerName: 'relatorio-ovn',
		routerPath: '/relatorio-ovn',
		componentName: 'RelatorioOvn',
		componentPath: 'modules/layout/relatorio/ovn/mg-siga/main'
	},
	{
		modulo: 7,
		privilegio: 147,
		routerName: 'relatorio-civ',
		routerPath: '/relatorio-civ',
		componentName: 'RelatorioCIV',
		componentPath: 'modules/layout/relatorio/civ/mg-siga/main'
	},
	{
		modulo: 7,
		privilegio: 147,
		routerName: 'relatorio-indisponibilidade',
		routerPath: '/relatorio-indisponibilidade',
		componentName: 'RelatorioIndisponibilidade',
		componentPath: 'modules/layout/relatorio/relatorio-indisponibilidade/main'
	},
	{
		modulo: 7,
		privilegio: 178,
		routerName: 'relatorio-horas-voadas-orgao',
		routerPath: '/relatorio-horas-voadas-orgao',
		componentName: 'RelatorioHorasVoadasOrgao',
		componentPath: 'modules/layout/relatorio/horas-voadas-orgao/default/main'
	},
	{
		modulo: 7,
		privilegio: 180,
		routerName: 'relatorio-controle-atividade-aerea',
		routerPath: '/relatorio-controle-atividade-aerea',
		componentName: 'RelatorioControleAtividadeAerea',
		componentPath: 'modules/layout/relatorio/controle-atividade-aerea/pmes/main'
	},
	{
		modulo: 7,
		privilegio: 182,
		routerName: 'relatorio-extrato-completo',
		routerPath: '/relatorio-extrato-completo',
		componentName: 'RelatorioExtratoCompleto',
		componentPath: 'modules/layout/relatorio/extrato-completo/pmes/main'
	},
	{
		modulo: 7,
		privilegio: 30,
		routerName: 'relatorioPrevencao',
		routerPath: '/relatorio-de-prevencao',
		componentName: 'RelatorioPrevencao',
		componentPath: 'modules/layout/relatorio/prevencao/alagoas/main'
	},
	{
		modulo: 7,
		privilegio: 248,
		routerName: 'relatorio-produtividade',
		routerPath: '/relatorio-produtividade',
		componentName: 'RelatorioProdutividade',
		componentPath: 'modules/layout/relatorio/produtividade/main'
	},
	{
		modulo: 26,
		privilegio: 254,
		routerName: 'relatorio-preco-medio',
		routerPath: '/relatorio-preco-medio',
		componentName: 'RelatorioPrecoMedio',
		componentPath: 'modules/layout/relatorio/relatorio-preco-medio/main'
	},
	{
		modulo: 26,
		privilegio: 255,
		routerName: 'relatorio-abastecimento-anual',
		routerPath: '/relatorio-abastecimento-anual',
		componentName: 'RelatorioAbastecimentoAnual',
		componentPath: 'modules/layout/relatorio/relatorio-abastecimento-anual/main'
	},
	{
		modulo: 26,
		privilegio: 257,
		routerName: 'relatorio-abastecimento-centro-custo',
		routerPath: '/relatorio-abastecimento-centro-custo',
		componentName: 'RelatorioAbastecimentoCentroCusto',
		componentPath:
			'modules/layout/relatorio/relatorio-abastecimento-centro-custo/main'
	},
	{
		modulo: 38,
		privilegio: 387,
		routerName: 'relatorio-historico-treinamentos',
		routerPath: '/relatorio-historico-treinamentos',
		componentName: 'RelatorioHistoricoTreinamentos',
		componentPath:
			'modules/layout/relatorio/relatorio-historico-treinamentos/main'
	},
	{
		modulo: 38,
		privilegio: 388,
		routerName: 'relatorio-vencimento-treinamentos',
		routerPath: '/relatorio-vencimento-treinamentos',
		componentName: 'RelatorioVencimentoTreinamentos',
		componentPath:
			'modules/layout/relatorio/relatorio-vencimento-treinamentos/main'
	},
	{
		modulo: 27,
		privilegio: 381,
		routerName: 'relatorio-reporte-fadiga',
		routerPath: '/relatorio-reporte-fadiga',
		componentName: 'RelatorioReporteFadiga',
		componentPath: 'modules/layout/relatorio/relatorio-reporte-fadiga/main'
	},
	{
		modulo: 7,
		privilegio: 392,
		routerName: 'RelatorioTrechosCelula',
		routerPath: '/relatorio-trechos-celula',
		componentName: 'RelatorioTrechosCelula',
		componentPath: 'modules/layout/relatorio/trecho-celula/main'
	},
	{
		modulo: 7,
		privilegio: 395,
		routerName: 'RelatorioTripulacaoAeronave',
		routerPath: '/relatorio-tripulacao-aeronave',
		componentName: 'RelatorioTripulacaoAeronave',
		componentPath: 'modules/layout/relatorio/tripulacao-aeronave/main'
	},
	{
		modulo: 7,
		privilegio: 404,
		routerName: 'RelatorioPosicoesVoo',
		routerPath: '/relatorio-posicoes-voo',
		componentName: 'RelatorioPosicoesVoo',
		componentPath: 'modules/layout/relatorio/posicoes-voo/main'
	},
	{
		modulo: 7,
		privilegio: 413,
		routerName: 'RelatorioManobrasEspeciais',
		routerPath: '/relatorio-manobras-especiais',
		componentName: 'RelatorioManobrasEspeciais',
		componentPath: 'modules/layout/relatorio/manobras-especiais/main'
	},
	{
		modulo: 7,
		privilegio: 424,
		routerName: 'rihv',
		routerPath: '/rihv',
		componentName: 'RelatorioRIHV',
		componentPath: 'modules/layout/relatorio/rihv/main'
	}
]
